import React from 'react';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';
import { Radio } from '@change-corgi/design-system-legacy/components/forms';

type TrackingContext = 'status_filter_trending' | 'status_filter_all' | 'status_filter_victories';

type StatusFilterProps = {
	setAllPetitions: () => void;
	setVictoriesOnly: () => void;
	setTrending: () => void;
	isAllPetitionsChecked: boolean;
	isVictoriesOnlyChecked: boolean;
	isTrendingChecked: boolean;
	disabled: boolean;
	trackStatusFilterClick: (context: TrackingContext) => void;
};

export const DesktopStatusFilter: React.FC<StatusFilterProps> = ({
	setAllPetitions,
	setVictoriesOnly,
	setTrending,
	isAllPetitionsChecked,
	isVictoriesOnlyChecked,
	isTrendingChecked,
	disabled,
	trackStatusFilterClick,
}) => {
	return (
		<div>
			<Text as="h2" variant="heading" size="x-small" fontWeight="normal" className="mb-4">
				<Translate value="corgi.search.filters.status.title" />
			</Text>
			<div className="flex flex-col flex-wrap gap-4">
				<RadioOption
					label={<Translate value="corgi.search.filters.status.options.all" />}
					value="all_petitions"
					onChange={() => {
						setAllPetitions();
						trackStatusFilterClick('status_filter_all');
					}}
					checked={isAllPetitionsChecked}
					disabled={disabled}
				/>
				<RadioOption
					label={<Translate value="corgi.search.filters.status.options.victories_only" />}
					value="victories_only"
					checked={isVictoriesOnlyChecked}
					onChange={() => {
						setVictoriesOnly();
						trackStatusFilterClick('status_filter_victories');
					}}
					disabled={disabled}
				/>
				<RadioOption
					label={<Translate value="corgi.search.filters.status.options.trending" />}
					value="trending"
					checked={isTrendingChecked}
					onChange={() => {
						setTrending();
						trackStatusFilterClick('status_filter_trending');
					}}
					disabled={disabled}
				/>
			</div>
		</div>
	);
};

const RadioOption: React.FC<{
	label: React.ReactNode;
	value: string;
	disabled: boolean;
	onChange: () => void;
	checked: boolean;
}> = ({ label, value, onChange, disabled, checked }) => {
	return (
		<Radio
			size="big"
			label={
				<Text variant="body" size="large" className="cursor-pointer select-none">
					{label}
				</Text>
			}
			value={value}
			checked={checked}
			name="status-filter"
			onChange={onChange}
			disabled={disabled}
			data-testid={`${value}_radio`}
			data-qa="status-filter-checkbox"
			sx={{
				accentColor: '#4771FF',
				cursor: 'pointer',
			}}
		/>
	);
};
